export default { countriesForNonSaudi: state => state.countries.filter(s => s.id !== 1) };
